(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("RPC"));
	else if(typeof define === 'function' && define.amd)
		define(["RPC"], factory);
	else if(typeof exports === 'object')
		exports["mailEMailRuFeedback"] = factory(require("RPC"));
	else
		root["mailEMailRuFeedback"] = factory(root["RPC"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__6093__) {
return 